import React, { useEffect, useState } from "react";
import { Tooltip } from "antd";
import { Sidebar } from "syngenta-digital-cropwise-react-ui-kit";
import "./sidebar.less";
import { useLocation } from "react-router-dom";
import { useAppState } from "../../lib/appContext/AppContext";
import { appURLs } from "../../lib/appRoutes/appUrls";
import { useTrialsRouter } from "../custom-hooks/useTrialsRouter";
import { useProtocolsRouter } from "../custom-hooks/useProtocolsRouter";
import { useSafeNavigate } from "../custom-hooks/useSafeNavigate";
import { useTranslation } from "react-i18next";
import { formatTranslation } from "../utils/translationUtils";

interface RouteInterface {
  name: string;
  path: string;
}

export const SidebarMenu: React.FC = (props) => {
  const { t } = useTranslation();
  const navigate = useSafeNavigate();
  const { pathname } = useLocation();
  const { stateValue, setStateValue } = useAppState();
  const {
    orgId: trialsOrgId,
    workspaceId: trialsWorkspaceId,
    farmId: trialsFarmId,
  } = useTrialsRouter();
  const {
    orgId: protocolsOrgId,
    workspaceId: protocolsWorkspaceId,
    farmId: protocolsFarmId,
  } = useProtocolsRouter();
  const orgId = trialsOrgId ?? protocolsOrgId;
  const workspaceId = trialsWorkspaceId ?? protocolsWorkspaceId;
  const farmId = trialsFarmId ?? protocolsFarmId;

  const isAssessment = window.location.pathname.toString().includes("reports")
    ? "REPORTS"
    : "";

  const [active, setActive] = useState(isAssessment);
  const routes: Record<string, RouteInterface> = {
    workspace: {
      name: formatTranslation(t("shared.myWorkspace")),
      path: `${appURLs.MY_CROPWISE}`,
    },
  };

  if (orgId && workspaceId && farmId) {
    routes.protocols = {
      name: formatTranslation(t("protocols")),
      path: `${appURLs.PROTOCOLS}/workspace/${workspaceId}/org/${orgId}/farm/${farmId}`,
    };
    routes.trials = {
      name: formatTranslation(t("trials")),
      path: `${appURLs.TRIALS}/workspace/${workspaceId}/org/${orgId}/farm/${farmId}`,
    };
  }
  const routesMap = Object.keys(routes);

  useEffect(() => {
    const routeKey = routesMap?.find((route) => {
      const routePath = `${routes[route].path}`;
      return pathname === routePath || pathname.startsWith(`${routePath}/`);
    });
    setActive(routeKey ?? "");
  }, [pathname]);

  return (
    <Sidebar
      data-cy="sidebar"
      test-id="sidebar"
      theme="dark"
      selectedKeys={[active]}
      collapsedMenu={true}
      menuItems={routesMap.map((route) => ({
        key: route,
        label: routes[route].name,
        icon: (
          <Tooltip title={routes[route].name} placement="right">
            <img
              className="sidebar-icon active"
              alt={route.toLowerCase()}
              src={require(`../../assets/images/${route
                .toLowerCase()
                .replaceAll("_", "-")}.svg`)}
            />
          </Tooltip>
        ),
        onClick: () => {
          if (route === "workspace") {
            setActive(route);
            navigate(`${routes[route].path}`);
            setStateValue({
              ...stateValue,
              farmValue: null,
            });
          } else {
            setActive(route);
            navigate(`${routes[route].path}/`);
          }
        },
      }))}
    />
  );
};
